import axios from 'axios';
import { SLACK_WEBHOOKS } from '../config';
import { FETCH_CURRENCY, FETCH_CURRENCY_FAIL, SET_CURRENCY } from './types';
import { SlackWebhook } from './utils';


/**
 * Fetch currency via Busabout API
 */
export function FetchCurrency() {
    return (dispatch) => {
      axios.get(`${process.env.REACT_APP_CURRENCY_API}?_=${new Date().getTime()}` )
      .then((data) => {
        dispatch({type:FETCH_CURRENCY, payload:data});
        dispatch({type:SET_CURRENCY, payload:data});
      })
      .catch((err) => {
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':`Botch! CURRENCY API -  ${process.env.REACT_APP_CURRENCY_API} ` + err}));
        dispatch({type:FETCH_CURRENCY_FAIL})
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/currency.js